/**
 * Created by hieult on 1/31/18.
 */
import urls from './urls';
import config from '../libs/webIMConfig';
import axios from 'axios';
import queryString from 'query-string';
import { addParamsToQueryString } from '../functions/utils';
import { IParamsRequest } from 'redhotpie-shared-lib/interfaces/IAction';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

const responseCreateAccount = {
  success: true,
  statusCode: 200,
  message: 'Execute success',
  data: {},
};

class RegisterApi {
  static createAccount(params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.CREATE_ACCOUNT;
    // return this.restClient.execute(url, ApiMethod.POST, params, true).then(res => {
    //   return res;
    // });
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } });
  }

  static getJoinToken() {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_JOIN_TOKEN;
    // return this.restClient.execute(url, ApiMethod.POST, params, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false, isAnonymousAccessToken: true } });
  }

  // TODO: Check if changing to use isAnonymous instead of customHeader is good
  static forgotPassword(params: IParamsRequest): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = `${urls.GET_FORGOT_PASSWORD}?${queryString.stringify(params, { arrayFormat: 'comma' })}`;

    // this.restClient.setHeaders({ Authorization: config.rhpAPI_KEY });
    // return this.restClient.execute(url, ApiMethod.GET, params, false, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false, Authorization: config.rhpAPI_KEY } });
  }

  static resetPassword(params: IParamsRequest): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = addParamsToQueryString(urls.GET_RESET_PASSWORD, params);
    // return this.restClient.execute(url, ApiMethod.GET, params).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  // static connectFacebook(params) {
  //   this.restClient = new RestClient();
  //   this.restClient.setBaseUrl(urls.DEV_RHPURL);
  //   let url = urls.CONNECT_FACEBOOK;
  //   return this.restClient.execute(url, ApiMethod.POST, params, true).then(res => {
  //     return res;
  //   });
  // }
  static checkFacebookAccount(params: IParamsRequest): Promise<IApiResponse> {
    // console.log(params)
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.AUT_RHPURL);
    const url = urls.AUTH_FACEBOOKID;
    // return this.restClient.execute(url, ApiMethod.POST, params, true).then(res => {
    //   return res;
    // });
    return axios.post(url, params, { baseURL: urls.AUT_RHPURL, headers: { isAnonymous: true } });
  }
  static signInApple(params: IParamsRequest, isWeb = false): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.AUT_RHPURL);
    const url = isWeb ? urls.AUTH_APPLE_WEB : urls.AUTH_APPLE;
    // return this.restClient.execute(url, ApiMethod.POST, params, true).then(res => {
    //   return res;
    // });
    return axios.post(url, params, { baseURL: urls.AUT_RHPURL, headers: { isAnonymous: true } });
  }
  static signInGoogle(params: IParamsRequest): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.AUT_RHPURL);
    const url = urls.AUTH_GOOGLE;
    // return this.restClient.execute(url, ApiMethod.POST, params, true).then(res => {
    //   return res;
    // });
    return axios.post(url, params, { baseURL: urls.AUT_RHPURL, headers: { isAnonymous: true } });
  }

  static sendMsgCode(params: IParamsRequest): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // this.restClient.setHeaders({ Authorization: config.rhpAPI_KEY });
    // return this.restClient.execute(urls.POST_SEND_MSG_CODE, ApiMethod.POST, params, false, true);
    const url = urls.POST_SEND_MSG_CODE;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false, Authorization: config.rhpAPI_KEY } });
  }

  static sendValidateMsgCode(params: IParamsRequest): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(urls.POST_VALIDATE_MSG_CODE, ApiMethod.POST, params);
    const url = urls.POST_VALIDATE_MSG_CODE;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } });
  }

  static updateNewPassword(body: IParamsRequest): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // this.restClient.setHeaders({ Authorization: config.rhpAPI_KEY });
    // return this.restClient.execute(urls.GET_FORGOT_PASSWORD, ApiMethod.PATCH, body, false, true);
    const url = urls.GET_FORGOT_PASSWORD;
    return axios.patch(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false, Authorization: config.rhpAPI_KEY } });
  }

  static postValidatePhoneNumberRequest(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_VALIDATE_PHONE_REQUEST;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false, isAnonymousAccessToken: true } });
  }

  static postValidatePhoneNumberCodeRequest(params: IParamsRequest): Promise<IApiResponse> {
    const url = urls.POST_VALIDATE_CODE_REQUEST;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false, isAnonymousAccessToken: true } });
  }

  static getValidateUserPromoCode(code: string): Promise<IApiResponse> {
    const url = urls.GET_VALIDATE_PROMO_CODE.replace('{Code}', code);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } });
  }

  static getJoinLandingPageData(code: string): Promise<IApiResponse> {
    const url = urls.GET_JOIN_LANDING_PAGE.replace('{Code}', code);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } });
  }
}

export default RegisterApi;
